import axios from "axios";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const baseURLI = "https://www.seadimahbobaapi.xyz/ankiduapi/api/v1";
//const baseURLI = "http://localhost:8088/api/v1";

const token = cookies.get("token");

var CryptoJS = require("crypto-js");
var bytes="";
var tk="";

if (token) {
     // Encrypt
  // Decrypt
  bytes =CryptoJS.AES.decrypt(token.toString(), 'cscode2021').toString(CryptoJS.enc.Utf8);

  tk= bytes.slice(101, bytes.length-1);
}


   const  data = {
        baseURL: baseURLI,
        responseType: "json",
        headers: {
            "Content-type": "application/json",
            "Accept": 'application/pdf',
            "authorization": `Bearer ${tk}`, 
         
        }
}


    

export default axios.create(data);




  
//export const baseURLImg =`http://localhost:8088/ftp/uploads/resize/`;

export const baseURLImg =`https://www.seadimahbobaapi.xyz/ankiduapi/ftp/uploads/resize/`;

export const IdAppCompany ="6aabb5fa-2ae3-42aa-8a14-01726df4e53a";
